import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFSlots, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import SlotsView from './SlotsView';
import AppointmentTimeSlotQuery from './AppointmentTimeSlotQuery';

export default class SlotsContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasFetched: false };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { filterStartDate, filterEndDate } = nextProps;
    if ((!this.props.filterStartDate.isSame(filterStartDate, 'day')
      || !this.props.filterEndDate.isSame(filterEndDate, 'day'))
      && filterStartDate.isSameOrBefore(filterEndDate)) {
      this.fetchAppointmentTimeSlots(
        new AppointmentTimeSlotQuery(
          nextProps.type,
          nextProps.id,
          nextProps.reasonId,
          filterStartDate,
          filterEndDate,
          nextProps.restrictToSectionId));
    }
  }

  componentDidMount() {
    this.fetchAppointmentTimeSlots(
      new AppointmentTimeSlotQuery(
        this.props.type,
        this.props.id,
        this.props.reasonId,
        this.props.filterStartDate,
        this.props.filterEndDate,
        this.props.restrictToSectionId));
  }

  fetchAppointmentTimeSlots(appointmentTimeSlotQuery) {
    this.setState({hasFetched: false});

    fetchAuthenticatedJSON(appointmentTimeSlotQuery.url, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('appointments')
      }
    })
    .then(({slots}) => this.props.onSlotsFetched(slots))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <SlotsView
        hasFetched={this.state.hasFetched}
        slots={this.props.slots}
        recurring={this.props.recurring}
        numberOfVisibleSlots={this.props.numberOfVisibleSlots}
        onShowMoreSlotsButtonClick={this.props.onShowMoreSlotsButtonClick}
        slotStartDate={this.props.startDate}
        slotOwnerId={this.props.ownerId}
        onSlotSelected={this.props.onSlotSelected}
        showGroupSessions={this.props.showGroupSessions}
        showSingleSessions={this.props.showSingleSessions}
        onSlotTypeDropdownChanged={this.props.onSlotTypeDropdownChanged}
        filterStartDate={this.props.filterStartDate}
        onFilterStartDateChanged={this.props.onFilterStartDateChanged}
        filterEndDate={this.props.filterEndDate}
        onFilterEndDateChanged={this.props.onFilterEndDateChanged}
        isService={this.props.type === "services"}
        serviceCalendarInstruction={this.props.serviceCalendarInstruction}
        serviceCalendarEnabled={this.props.serviceCalendarEnabled}
        currentDuration={this.props.currentDuration}
        locationName={this.props.locationName}
      />
    );
  }
}

SlotsContainer.propTypes = {
  type: PropTypes.oneOf(['connections', 'services']).isRequired,
  slots: SFSlots,
  recurring: PropTypes.bool,
  onSlotsFetched: PropTypes.func,
  id: SFEntityID.isRequired,
  reasonId: SFEntityID.isRequired,
  startDate: PropTypes.object,
  ownerId: SFEntityID,
  onSlotSelected: PropTypes.func,
  currentDuration: PropTypes.number,
  restrictToSectionId: SFEntityID,
  locationName: PropTypes.string,
  onFailure: PropTypes.func,
  filterStartDate: PropTypes.object.isRequired,
  onFilterStartDateChanged: PropTypes.func.isRequired,
  filterEndDate: PropTypes.object.isRequired,
  onFilterEndDateChanged: PropTypes.func.isRequired,
  serviceCalendarInstruction: PropTypes.string,
  serviceCalendarEnabled: PropTypes.bool,

  // Injected by FilterControls, can't be required because they are dynamic
  numberOfVisibleSlots: PropTypes.number,
  onShowMoreSlotsButtonClick: PropTypes.func,
  showGroupSessions: PropTypes.bool,
  showSingleSessions: PropTypes.bool,
  onSlotTypeDropdownChanged: PropTypes.func,
};
